import { render } from "./SubmitFooter.vue?vue&type=template&id=5e38f1a8"
import script from "./SubmitFooter.vue?vue&type=script&lang=js"
export * from "./SubmitFooter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__